"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SpinDomain;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
function SpinDomain({
  Extension,
  Fqdn,
  isMobile,
  isPremium,
  NameWithoutExtension,
  sldStyle = {},
  tldStyle = {},
  premiumTldStyle = {},
  enableDynamicFontScaling = false,
  fontSize = {}
}) {
  const {
    mobile = 'ms1',
    desktop = 'ms4'
  } = sldStyle?.fontSize || fontSize;
  const outerClass = (0, _classnames.default)('spin-domain mr-1', isMobile ? mobile : desktop, {
    'spin-domain-dynamic-font-scaling': enableDynamicFontScaling
  });
  const innerClass = (0, _classnames.default)('text-nowrap d-inline-block', {
    'text-purple': isPremium && !premiumTldStyle?.color,
    'font-weight-semibold': !isPremium && !tldStyle?.fontWeight || isPremium && !premiumTldStyle?.fontWeight
  });
  const tldDataCy = `spin-${isPremium ? 'premium-' : ''}domain-tld`;
  return /*#__PURE__*/_react.default.createElement("span", {
    id: Fqdn,
    className: outerClass,
    dir: "ltr",
    "data-cy": "spin-domain",
    "data-testid": "spin-domain"
  }, /*#__PURE__*/_react.default.createElement("span", {
    style: sldStyle,
    "data-cy": "spin-domain-sld",
    "data-testid": "spin-domain-sld"
  }, NameWithoutExtension), /*#__PURE__*/_react.default.createElement("span", {
    className: innerClass,
    style: isPremium ? premiumTldStyle : tldStyle,
    "data-testid": "spin-domain-tld"
  }, /*#__PURE__*/_react.default.createElement("span", null, "."), /*#__PURE__*/_react.default.createElement("span", {
    "data-cy": tldDataCy
  }, Extension)));
}
SpinDomain.propTypes = {
  Extension: _propTypes.default.string.isRequired,
  Fqdn: _propTypes.default.string.isRequired,
  isMobile: _propTypes.default.bool,
  isPremium: _propTypes.default.bool,
  NameWithoutExtension: _propTypes.default.string.isRequired,
  sldStyle: _propTypes.default.object,
  tldStyle: _propTypes.default.object,
  premiumTldStyle: _propTypes.default.object,
  enableDynamicFontScaling: _propTypes.default.bool,
  fontSize: _propTypes.default.shape({
    mobile: _propTypes.default.string,
    desktop: _propTypes.default.string
  })
};